/**
 * useSettingsSave Hook
 *
 * Custom hook for handling settings save logic.
 * Single Responsibility: Manage save state and logic
 */
import { useState } from 'react';
import { saveFreeShippingBarSettings } from '../utils/saveFreeShippingBarSettings';

export const useSettingsSave = (onSuccess, onError) => {
  const [loading, setLoading] = useState(false);

  const saveSettings = async (settings) => {
    setLoading(true);
    try {
      await saveFreeShippingBarSettings(settings);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return { saveSettings, loading };
};
